// Free product guard.
// On any cart change: if a line has no approved-add property
// AND the product has metafield custom.free_product = true → clear the cart.
// Approved-add property name is configured in theme settings and exposed via
// window.__themeConfig.freeProductProperty.

(function () {
  'use strict';
  if (window.__freeProductGuardInstalled) return;
  window.__freeProductGuardInstalled = true;

  var APPROVED_PROP = (window.__themeConfig && window.__themeConfig.freeProductProperty) || '_is_free_product';
  var busy = false;
  var freeCache = new Map(); // handle → Promise<boolean>, dedupes section fetches

  function isFreeProduct(handle) {
    if (freeCache.has(handle)) return freeCache.get(handle);
    var p = fetch('/products/' + encodeURIComponent(handle) + '?sections=free-product-check')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return false;
        var html = j['free-product-check'] || '';
        return html.replace(/<[^>]*>/g, '').trim() === '1';
      })
      .catch(function () { return false; });
    freeCache.set(handle, p);
    return p;
  }

  function isApproved(item) {
    return !!(item.properties && item.properties[APPROVED_PROP] === 'true');
  }

  async function clearCart() {
    console.warn('[free-product-guard] unauthorized free product; clearing cart');
    await fetch('/cart/clear.js', { method: 'POST' });
    document.dispatchEvent(new CustomEvent('cart:changed', {
      bubbles: true,
      detail: { source: 'free-product-guard' }
    }));
  }

  // Fast path: /cart/add.js's response body IS the new line item. Inspect it
  // directly instead of round-tripping through /cart.js.
  //   returns true  → violation detected (cleared by caller)
  //   returns false → add was clean
  //   returns null  → couldn't determine; caller should run full check
  async function checkAdd(e) {
    if (!e.detail || e.detail.endpoint !== 'add' || !e.detail.response) return null;
    try {
      var item = await e.detail.response.json();
      if (!item || !item.handle) return null;
      if (isApproved(item)) return false;
      return await isFreeProduct(item.handle);
    } catch (_) {
      return null;
    }
  }

  // Full check: fetch the whole cart and race all unapproved lines.
  // First free product detected → clear immediately.
  async function checkFull() {
    if (busy) return;
    busy = true;
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var candidates = cart.items.filter(function (i) { return !isApproved(i) && i.handle; });
      if (candidates.length === 0) return;
      try {
        await Promise.any(candidates.map(function (i) {
          return isFreeProduct(i.handle).then(function (free) {
            return free ? Promise.resolve() : Promise.reject();
          });
        }));
        await clearCart();
      } catch (_) {
        // All non-free → no violation
      }
    } finally {
      busy = false;
    }
  }

  document.addEventListener('cart:changed', async function (e) {
    if (e.detail && e.detail.source === 'free-product-guard') return;
    var fast = await checkAdd(e);
    if (fast === true) { await clearCart(); return; }
    if (fast === false) return;
    checkFull();
  });

  // Page-load sweep: catches stale free items in the cart from a previous
  // session (added before the guard existed, before a product was tagged
  // free, or while the guard was disabled).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkFull);
  } else {
    checkFull();
  }
})();

